import router from "./router/index";

router.beforeEach(async (to, from, next) => {
    document.title = to.meta.title;

    next();
});
